import React from "react";
import styled from "styled-components";
import { IBlogAuthor } from "types/interfaces/blog/IBlog";
import { Typography } from "@beamcloud/design-system";
import { sanityImgBuilder as builder } from "../sanity";

interface IProps {
  author: IBlogAuthor;
  size?: "base" | "small";
  className?: string;
}

const Author = ({ className, author, size = "base" }: IProps) => {
  return (
    <Container className={className}>
      <ProfileImage src={builder.image(author.image).url()} alt="author-profile-pic" />
      <Typography tag="span" variant={size === "base" ? "textBase" : "textSm"} color="gray300">
        {author.name}
      </Typography>
    </Container>
  );
};

export default Author;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const ProfileImage = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: white;
`;
